import {createSvgIcon} from "@mui/material";

const MinusCircleIcon = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g>
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="currentColor"/>
      <path d="M8 16H24" stroke="currentColor"/>
    </g>
  </svg>
  , 'Minus')

export default MinusCircleIcon;
